<template>
  <b-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            @click="resetIndex"
            class="input-new"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-else-if="filter2 === '2'">
          <b-form-input
            v-model="form.email"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            @click="resetIndex"
            class="input-new"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-else-if="filter2 === '3'">
          <b-form-select
            v-model="form.access_lvl"
            :options="select.role"
            required
            @change="resetIndex"
            class="input-new"
          />
        </b-input-group>
        <b-input-group v-else-if="filter2 === '4'">
          <b-form-select
            v-model="form.state"
            :options="select.state"
            required
            @change="resetIndex"
            class="input-new"
          />
        </b-input-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <!-- TABLE -->
    <b-table
      head-variant="dark"
      show-empty
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(action)="data">
        <b-row>
          <b-col sm="1">
            <b-link @click="onClickView(data.item.id)"
              ><i class="ti-file" style="font-size:20px;"></i
            ></b-link>
          </b-col>
          <b-col sm="1">
            <b-link @click="onClickUpdate(data.item.id)"
              ><i class="ti-pencil-alt" style="font-size:20px;"></i
            ></b-link>
          </b-col>
          <b-col sm="1">
            <b-link @click="onClickDelete(data.item.id)"
              ><i class="ti-trash" style="font-size:20px;"></i
            ></b-link>
          </b-col>
          <b-col sm="1">
            <b-link @click="onClickChangePW(data.item.id)"
              ><i class="ti-user" style="font-size:20px;"></i
            ></b-link>
          </b-col>
        </b-row>
      </template>
    </b-table>
    <b-pagination
      v-if="!isLoading"
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination>

    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickCreate">
          CREATE
        </b-button>
      </b-col>
    </b-row>
    <br /><br />
    <b-row>
      <b-col md="4">
        <label>State <span class="danger-new">*</span></label>
        <b-form-group>
          <b-form-select
            v-model="input.state"
            :options="select.state"
            required
            class="input-new"
            @change="getUpline"
          />
          <p v-if="error.state">
            <span class="danger-new">{{ this.error.state }}</span>
          </p>
        </b-form-group>
      </b-col>
      <b-col md="4" v-if="input.state !== 0">
        <label>Stockist</label>
        <b-form-select
          v-model="input.stockist"
          :options="select.stockist"
          required
          class="input-new"
        />
      </b-col>
      <b-col md="4" style="padding-top:27px;">
        <b-form-group>
          <b-button variant="primary" class="input-new" @click="onDownloadUser"
            >Download User</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <!-- POPUP DELETE -->

    <b-modal id="modal-delete" title="Delete Confirmation">
      <p>
        Are you sure you want to delete ?
      </p>

      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          CLOSE
        </b-button>
        <b-button variant="danger" size="sm" @click="onClickDeleteConfirm">
          DELETE
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SuccessGenerateReport from "@/pages/Notifications/SuccessGenerateReport";
import Failed from "@/pages/Notifications/Failed";
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,

      items: [],
      filter2: null,
      select: {
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Name", value: "1" },
          { text: "Email", value: "2" },
          { text: "Role", value: "3" },
          { text: "State", value: "4" }
        ],
        state: [{ text: "Please Select", value: null }],
        stockist: [{ text: "Please Select", value: "" }],
        role: [{ text: "Please Select", value: null }]
      },
      form: {
        name: null,
        state: null,
        access_lvl: null,
        email: null,
        page: 1
      },
      indexsearch: 1,
      input: {
        state: null,
        stockist: ""
      },
      error: {
        state: ""
      },
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      }
    };
  },
  components: {
    Loading
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  created() {
    if (this.filter) {
      this.filter2 = this.filter !== "null" ? this.filter : null;
      this.pagination.current = this.page !== "null" ? this.page : null;
      this.indexsearch = this.page !== "null" ? this.page : null;
      this.form.name = this.name !== "null" ? this.name : null;
      this.form.state = this.state !== "null" ? this.state : null;
      this.form.access_lvl =
        this.access_lvl !== "null" ? this.access_lvl : null;
      this.form.email = this.email !== "null" ? this.email : null;

      if (this.filter !== "null") {
        this.onClickSearch();
      } else {
        this.pagination.current = this.page !== "null" ? this.page : null;
        this.getUser();
      }
    } else {
      this.getUser();
    }

    this.getState();
    this.getRole();
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    filter: {
      type: String,
      default: null
    },
    page: {
      type: String
    },
    name: {
      type: String
    },
    state: {
      type: String
    },
    access_lvl: {
      type: String
    },
    email: {
      type: String
    }
  },
  methods: {
    onClickCreate() {
      this.$router.push({ path: `user_create` });
    },
    onClickUpdate(id) {
      this.$router.push({
        path: `user_update?id=${id}&filter=${this.filter2}&page=${this.pagination.current}&name=${this.form.name}&state=${this.form.state}&access_lvl=${this.form.access_lvl}&email=${this.form.email}`
      });
    },
    onClickView(id) {
      this.$router.push({
        path: `user_view?id=${id}&filter=${this.filter2}&page=${this.pagination.current}&name=${this.form.name}&state=${this.form.state}&access_lvl=${this.form.access_lvl}&email=${this.form.email}`
      });
    },
    onClickChangePW(id) {
      this.$router.push({
        path: `changepw_user?id=${id}&filter=${this.filter2}&page=${this.pagination.current}&name=${this.form.name}&state=${this.form.state}&access_lvl=${this.form.access_lvl}&email=${this.form.email}`
      });
    },
    onClickBack() {
      this.$bvModal.hide("modal-user");
    },
    onClickDelete(id) {
      this.deleteIndex = id;
      this.$bvModal.show("modal-delete");
    },
    onClickDeleteConfirm() {
      const form = {
        user_id: this.deleteIndex
      };
      this.$store.dispatch("deleteUser", form).then(res => {
        if (res.data.response.code === 1) {
          this.$bvModal.hide("modal-delete");
          this.getUser();
        }
      });
    },
    resetFilter() {
      this.form.name = null;
      this.form.state = null;
      this.form.email = null;
      this.form.access_lvl = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.name = null;
      this.form.state = null;
      this.form.email = null;
      this.form.access_lvl = null;
      this.pagination.current = 1;
      this.getUser();
    },
    onClickSearch() {
      // let page = this.pagination.current !== this.pagination.startIndex ? this.pagination.startIndex : this.pagination.current
      this.form.page = this.indexsearch;
      if (this.filter2 === null) {
        this.getUser();
      } else {
        this.isLoading = true;
        this.$store.dispatch("searchUser", this.form).then(res => {
          this.isLoading = false;
          this.items = [];
          res.data.data.data.forEach(element => {
            this.items.push({
              name: element.name,
              role: element.role_details.desc,
              state: element.state_details.desc,
              id: element.user_id
            });
          });
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
      }
    },
    getUser() {
      //reset array
      this.isLoading = true;
      this.items = [];
      this.$store.dispatch("getUser", this.pagination.current).then(res => {
        this.isLoading = false;
        res.data.data.data.forEach(element => {
          this.items.push({
            name: element.name,
            role: element.role_details.desc,
            state: element.state_details.desc,
            id: element.user_id
          });
        });
        this.pagination.total = res.data.data.total;
        this.pagination.current = res.data.data.current_page;
        this.pagination.perPage = res.data.data.per_page;
        this.pagination.startIndex = res.data.data.from;
      });
    },
    getUpline() {
      this.input.stockist = "";
      this.select.stockist = [];
      this.select.stockist.push({ value: "", text: "Please Select" });
      this.$store.dispatch("getUplineStock", this.input.state).then(res => {
        res.data.data.forEach(element => {
          this.select.stockist.push({
            value: element.user_id,
            text: element.name
          });
        });
      });
    },
    getState() {
      this.$store.dispatch("getReftable", "state&all=1").then(res => {
        res.data.data.state.forEach(element => {
          this.select.state.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
    },
    getRole() {
      this.$store.dispatch("getReftable", "role").then(res => {
        res.data.data.role.forEach(element => {
          this.select.role.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
    },
    resetIndex() {
      this.indexsearch = 1;
    },
    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        this.getUser();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        // this.indexsearch++
        this.onClickSearch();
      }
    },
    checkForm: function() {
      if (this.input.state) return true;
      this.error.state = "";

      if (this.input.state === null) {
        this.error.state = "State required.";
      }
      // e.preventDefault();
    },
    onDownloadUser() {
      this.error.state = "";
      this.checkForm();

      if (!this.error.state) {
        let data = {
          user_id: this.input.state === 0 ? "" : this.input.stockist,
          state: this.input.state === 0 ? "0" : this.input.state
        };
        this.isLoading = true;
        this.$store.dispatch("downloadUser", data).then(res => {
          this.isLoading = false;

          if (res.data.response.code === 100) {
            this.$notify({
              component: SuccessGenerateReport,
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });

            window.open(
              `${process.env.VUE_APP_BASE_URL}/${res.data.data.path + ".xlsx"}`,
              "_blank"
            );
          } else {
            this.$notify({
              component: Failed,
              icon: "ti-close",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          }
        });
      }
    }
  }
};
</script>
<style lang="css" scoped></style>
